module.exports = __webpack_public_path__ + "img/billing_wadiah_report.b5ea068a.svg";